/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AddPointDialogComponent from "./addPointDialog.component";
import { useDispatch, useSelector } from "react-redux";
import loyaltyPointApi from "app/api/loyaltyProgram";
import { addAlert } from "modules/notification";
import { getApiLang, getLang } from "app/feature/constants";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";

export default function AddPointDialogContainer({
  isOpen,
  handleClose,
  id,
  type, // 'create' or 'edit'
  handleReload,
}) {
  const dispatch = useDispatch();
  const hasLoyaltyProgramAddAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_WRITE_CREATE)
  );
  const hasLoyaltyProgramEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.LoyaltyProgram.LOYALTY_POINT_WRITE_UPDATE)
  );
  const lang = useSelector((state) => state.constant.languages);
  const language = useSelector((state) => state.profile.language);

  const [detail, setDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (id && isOpen) {
      fetchData();
    }
  }, [id, isOpen]);

  const fetchData = async () => {
    setIsLoading(true);
    setIsError(false);

    loyaltyPointApi
      .getLoyaltyPoint(id)
      .then((res) => {
        res.data.products = res.data.products.map((item) => ({
          ...item,
          id: item.uuid,
        }));
        setDetail(res.data);
      })
      .catch((error) => {
        dispatch(
          addAlert({
            severity: "error",
            message: getApiLang(lang, error.code),
          })
        );
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = async (values) => {
    if (type === "create") {
      if (hasLoyaltyProgramAddAccessRight) {
        setIsSubmitting(true);

        const info = {
          product_uuids: values.products.map((p) => p.id),
          point: values.point,
          instant_win_uuids: values.instantWins.map((iw) => iw.uuid),
        };
        loyaltyPointApi
          .addLoyaltyPoint(info)
          .then((r) => {
            dispatch(
              addAlert({
                severity: "success",
                message: getLang(
                  lang,
                  "message.success.POINT_ADDED_SUCCESSFULLY"
                ),
              })
            );
            handleClose();
            handleReload();
          })
          .catch((error) => {
            dispatch(
              addAlert({
                severity: "error",
                message: getApiLang(lang, error.code),
              })
            );
          })
          .finally(() => {
            setIsSubmitting(false);
          });
      }
    } else {
      if (hasLoyaltyProgramEditAccessRight) {
        setIsSubmitting(true);
        const info = {
          product_uuids: values.products.map((p) => p.id),
          point: values.point,
          instant_win_uuids: values.instantWins.map((iw) => iw.uuid),
          uuid: id,
        };

        loyaltyPointApi
          .updateLoyaltyPoint(info)
          .then((r) => {
            dispatch(
              addAlert({
                severity: "success",
                message: getLang(
                  lang,
                  "message.success.POINT_ADDED_SUCCESSFULLY"
                ),
              })
            );
            handleClose();
            handleReload();
          })
          .catch((error) => {
            dispatch(
              addAlert({
                severity: "error",
                message: getApiLang(lang, error.code),
              })
            );
          })
          .finally(() => {
            setIsSubmitting(false);
          });
      }
    }
  };

  return (
    <>
      <AddPointDialogComponent
        isOpen={isOpen}
        handleClose={handleClose}
        id={id}
        hasLoyaltyProgramAddAccessRight={hasLoyaltyProgramAddAccessRight}
        hasLoyaltyProgramEditAccessRight={hasLoyaltyProgramEditAccessRight}
        detail={detail}
        handleSubmit={handleSubmit}
        lang={lang}
        type={type}
        isSubmitting={isSubmitting}
        language={language}
        isLoading={isLoading}
        isError={isError}
        handleReload={fetchData}
      />
    </>
  );
}
